import { createContext } from 'react';

export type SettingsType = {
  duration: number;
  rest: number;
  repeats: number;
};

export type SettingsContextType = SettingsType & {
  update: (newSettings: Partial<SettingsType>) => void;
};

export const initialSettings = {
  duration: 30,
  rest: 10,
  repeats: 0,
};

const SettingsContext = createContext<SettingsContextType>({ ...initialSettings, update: () => {} });

export default SettingsContext;
